import * as Yup from 'yup'

export const INVOICE_REQUIRED_MSG = 'Bitte füllen Sie dieses Feld korrekt aus.'

/**
 * Validation schema for the create-invoice form.
 *
 * `invoiceNumber` is required only while the "Andere Rechnungsnummer" switch is on
 * (`useCustomInvoiceNumber === true`); once it is off the field is optional again. Keeping
 * this rule here — rather than inline in the dialog — lets it be exercised directly in tests
 * (see SIB-860, where deselecting the switch used to leave a stuck required error).
 */
export const makeInvoiceValidationSchema = () =>
  Yup.object({
    bankId: Yup.number().required(INVOICE_REQUIRED_MSG),

    mode: Yup.mixed<'MONTH' | 'DATE_RANGE' | 'ACTIVITY_SELECTION'>()
      .oneOf(['MONTH', 'DATE_RANGE', 'ACTIVITY_SELECTION'])
      .required(INVOICE_REQUIRED_MSG),

    useCustomInvoiceNumber: Yup.boolean(),

    invoiceNumber: Yup.string().when('useCustomInvoiceNumber', {
      is: true,
      then: s => s.trim().required(INVOICE_REQUIRED_MSG),
      otherwise: s => s.optional(),
    }),

    billingMonth: Yup.number().when('mode', {
      is: 'MONTH',
      then: s => s.min(1).max(12).required(INVOICE_REQUIRED_MSG),
      otherwise: s => s.optional(),
    }),

    billingYear: Yup.number().when('mode', {
      is: 'MONTH',
      then: s => s.min(2020).max(2100).required(INVOICE_REQUIRED_MSG),
      otherwise: s => s.optional(),
    }),

    periodStart: Yup.string().when('mode', {
      is: 'DATE_RANGE',
      then: s => s.required(INVOICE_REQUIRED_MSG),
      otherwise: s => s.optional(),
    }),

    periodEnd: Yup.string().when('mode', {
      is: 'DATE_RANGE',
      then: s => s.required(INVOICE_REQUIRED_MSG),
      otherwise: s => s.optional(),
    }),

    selectedActivityIds: Yup.array(Yup.number()).when('mode', {
      is: 'ACTIVITY_SELECTION',
      then: s => s.min(1, 'Bitte wählen Sie mindestens eine Aktivität aus.'),
      otherwise: s => s.optional(),
    }),

    comment: Yup.string().max(3000, 'Maximal 3000 Zeichen.').optional(),
  })
